import React from "react";
import Navbar from "../components/Navbar";

import Footer from "../components/Footer";
import ImageCarousel from "../components/Carousel";
import ProjectCard from "../components/ProjectCard";
import ProjectDesciption from "../components/ProjectDescription";

/* src="./Semester_5/17.1.png" */

const Project1 = () => {
    const carouselImages = [
        {
          src: "./Semester_2/ObenMittigschwarzweisstransformed.webp",
          alt: "Model",
          text: "Model Bird's Eye View"
        },
        {
          src: "./Semester_2/seiteschwarzweiss1.webp",
          alt: "Model2",
          text: "Model Oblique View"
        },
        {
          src: "./Semester_2/2.webp",
          alt: "Blackwhite",
          text: "Building To Free Space Ratio"
        }
      ];


        const title = "QuadraVive";
        const subtitle = "A Residential Complex between Trees";
        const description = "In Poblenou, a district of Barcelona, an urban development project on the scale of a “supercuadra” is being planned. The project aims to create a harmonious integration of apartments and studio buildings in a spacious, public park landscape. Living and working takes place on different levels of the trees. This vertical structure is intended to offer residents not only a special atmosphere and closeness to nature, but also privacy thanks to the natural screening provided by the trees.";
        const secondDescription = "The project is divided into a park level and a bridge level above, on which the residential and studio areas are arranged. These bridges can be reached via eight staircases distributed throughout the park. The park is designed to be inviting from all sides and to make the public space accessible to residents. This promotes social life and strengthens the community at the same time. The park becomes a meeting place, a family-friendly and animal-friendly space, a place to rest - a small recreational area. The shading effect of the trees is particularly important during the hot summer months. Poblenou and its surroundings have a lack of green spaces. There are housing estates, warehouses and work areas all around, so the park area is of central importance for the residents in and around the Supercuadra.";
        const thirdDescription = "The modules - the houses - are placed on supports to keep the park space as free as possible. The modules are divided into three size categories: Type A, Type B and Type C, with Type A being the smallest and also the tallest module. Each of these modules is equipped with two terraces. The floor plan of each module is C-shaped and rotates from floor to floor, ensuring a dynamic room layout and an ever-changing view. The room function follows a logical sequence - first the kitchen, then the dining room, living room, bathroom, bedroom and, at the top, the studio."
        const map = "./Semester_2/Karten.webp";
        const semester = "Springsemester 2023";
        const professosr = "2nd semester at Deplazes";
        const tools = "created with ArchiCAD";
        const coAuthor = "";


    const cards = [
      {
        id: 1,
        content: <p>Park level</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/1.webp",
      },
      {
        id: 2,
        content: <p>Bridge system at residential level</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/2Kopie.webp",
      },
      {
        id: 3,
        content: <p>Cut section showcasing the composition of living and leisure spaces</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/3.webp",
      },
      {
        id: 4,
        content: <p>First and fourth storey. Privacy through rotation of modules and through dense flora.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/4.webp",
      },
      {
        id: 5,
        content: <p>Module A is the tallest type with six floors and 16 square metres.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/5.webp",
      },
      {
        id: 6,
        content: <p>floor plans in rotation clockwise.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/6.webp",
      },
      {
        id: 7,
        content: <p>Module B</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/7.webp",
      },
      {
        id: 8,
        content: <p>Each module consists of 2 balconies with folding windows.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/8.webp",
      },
      {
        id: 9,
        content: <p>The top floor overlooks the tree layers and houses the studio space</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/9.webp",
      },
      {
        id: 10,
        content: <p>Module C is the smalles with the largest area.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/10.webp",
      },
      {
        id: 11,
        content: <p>On each floor up to two activities take place.</p>,
        className: "h-40 bg-transparent",
        thumbnail: "./Semester_2/11.webp",
      },
    ];
    
  return (
    <>
    <div className="pb-25 flex items-center justify-center bg-[#e7e5e4]">
        <Navbar />
    </div>
      <ImageCarousel images={carouselImages} title={title} />
      <ProjectDesciption subtitle={subtitle} description={description} secondDescription={secondDescription} thirdDescription={thirdDescription} map={map} semester={semester} professor={professosr} tools={tools} coAuthor={coAuthor}/>
      <ProjectCard cards={cards}/>
      <Footer />
    </>
  );
};

export default Project1;

